<template>
  <div>
    <button
      type="button"
      class="h-12 w-full items-center gap-2 rounded-[10px] pl-5 pr-3 text-sm text-placeholder-purple border border-gray-575/30 transition hover:border-gray-575/50 focus:outline-none flex bg-gray-575/30"
      @click="searchDialogIsOpen = true"
    >
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="shrink-0">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.58335 2.29169C8.62579 2.29169 7.67761 2.48031 6.79295 2.84674C5.90828 3.21318 5.10445 3.75028 4.42736 4.42738C3.75026 5.10447 3.21316 5.9083 2.84673 6.79297C2.48029 7.67763 2.29168 8.62581 2.29168 9.58337C2.29168 10.5409 2.48029 11.4891 2.84673 12.3738C3.21316 13.2584 3.75026 14.0623 4.42736 14.7394C5.10445 15.4165 5.90828 15.9536 6.79295 16.32C7.67761 16.6864 8.62579 16.875 9.58335 16.875C11.5172 16.875 13.3719 16.1069 14.7393 14.7394C16.1068 13.3719 16.875 11.5172 16.875 9.58337C16.875 7.6495 16.1068 5.79483 14.7393 4.42738C13.3719 3.05993 11.5172 2.29169 9.58335 2.29169ZM1.04168 9.58337C1.04168 4.86669 4.86668 1.04169 9.58335 1.04169C14.3 1.04169 18.125 4.86669 18.125 9.58337C18.125 11.7167 17.3425 13.6684 16.0492 15.165L18.775 17.8917C18.8364 17.9489 18.8856 18.0179 18.9198 18.0946C18.954 18.1713 18.9724 18.254 18.9739 18.338C18.9754 18.4219 18.9599 18.5052 18.9285 18.583C18.897 18.6608 18.8502 18.7316 18.7909 18.7909C18.7316 18.8502 18.6608 18.897 18.583 18.9285C18.5052 18.9599 18.4219 18.9754 18.3379 18.9739C18.254 18.9724 18.1713 18.954 18.0946 18.9198C18.0178 18.8856 17.9489 18.8365 17.8917 18.775L15.165 16.0492C13.6152 17.391 11.6332 18.1281 9.58335 18.125C4.86668 18.125 1.04168 14.3 1.04168 9.58337Z" fill="#C1A2D0"/>
      </svg>

      <span>{{ $t('navbar.search_placeholder') }}</span>
      <kbd class="ml-auto text-2xs text-placeholder-purple opacity-60">
        <kbd class="font-sans">{{ modifierKey }}</kbd>
        <kbd class="font-sans">K</kbd>
      </kbd>
    </button>

    <b-search-dialog v-model="searchDialogIsOpen" />
  </div>
</template>

<script setup lang="ts">
import BSearchDialog from "~/components/navigation/search/BSearchDialog.vue";

const modifierKey = ref("");

onMounted(() => {
  if (import.meta.browser) {
    modifierKey.value = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform)
      ? "⌘"
      : "Ctrl ";
  }
});

const searchDialogIsOpen = ref(false);
</script>
